export const SIGN_IN_URL = "/auth/signIn";
export const SIGN_OUT_URL = "/auth/signOut";
